<template>
  <div class="globalConfigs">
    <form class="uk-form-stacked uk-flex-center uk-flex">
      <div class="">
        <label class="uk-form-label">Months</label>
        <input
          class="uk-input"
          :value="config.monthCount"
          type="number"
          v-on:input="update('monthCount', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Starting subscribers</label>
        <input
          class="uk-input"
          :value="config.startingSubscribers"
          type="number"
          v-on:input="update('startingSubscribers', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left"></div>
      <div class="uk-margin-left"></div>
    </form>
    <form class="uk-form-stacked uk-flex-center uk-flex uk-padding">
      <div class="">
        <label class="uk-form-label">Budget</label>
        <input
          class="uk-input"
          :value="config.budget"
          type="number"
          v-on:input="update('budget', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">CPS</label>
        <input
          class="uk-input"
          :value="config.CPS"
          type="number"
          v-on:input="update('CPS', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Trial Conversion</label>
        <input
          class="uk-input"
          :value="config.trialConversion"
          type="number"
          v-on:input="update('trialConversion', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Monthly Churn</label>
        <input
          class="uk-input"
          :value="config.churn"
          type="number"
          v-on:input="update('churn', $event.target.value)"
        />
      </div>
      <div class="uk-margin-left">
        <label class="uk-form-label">Organic Signups</label>
        <input
          class="uk-input"
          :value="config.signUpsOrganic"
          type="number"
          v-on:input="update('signUpsOrganic', $event.target.value)"
        />
      </div>
    </form>
    <br />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "GlobalConfigs",
  props: {
    id: String
  },
  methods: {
    ...mapActions({
      updateConfigs: "churn/updateConfigs"
    }),
    update(field, value) {
      let o = {
        id: this.id
      };
      o[field] = value;
      this.updateConfigs(o);
    }
  },
  computed: {
    ...mapGetters({
      getConfigById: "churn/getConfigByID"
      // ...
    }),
    config() {
      if (this.getConfigById) {
        return this.getConfigById(this.id);
      }
      return {};
    }
  }
};
</script>
